import type { ReactNode } from 'react';
import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import { Typography } from '@src/components/Typography/Typography';
import './Badge.css';

/**
 * neutral — nothing has happened yet.
 * info — in progress, or a label for what a screen is.
 * success — the participant got there.
 * warning — needs the organizer's attention.
 */
export type BadgeTone = 'neutral' | 'info' | 'success' | 'warning';

export interface BadgeProps {
  children: ReactNode;
  tone?: BadgeTone;
  testId?: string;
  className?: string;
}

export function Badge({ children, tone = 'neutral', testId, className }: BadgeProps) {
  return (
    <Typography
      as="span"
      role="meta/caps"
      className={classes('badge', tone !== 'neutral' && `badge--${tone}`, className)}
      {...testIdAttr(testId)}
    >
      {children}
    </Typography>
  );
}
